import { useState } from "react";

import { useToast } from "@/ds";
import type { MonthRangeValue } from "@/ds";

import { erroDoPeriodo, periodoDoAno } from "../carga-de-trabalho.utils";

/** O período da Carga: a tela o mantém e o entrega às abas, para a troca de perspectiva não perdê-lo (HU 2023, 2220). */
export interface CargaPeriodo {
  readonly periodo: MonthRangeValue;
  readonly escolherPeriodo: (range: MonthRangeValue) => void;
}

/** Período da perspectiva (Mês/Ano): um intervalo recusado (fim antes do início, mais de 36 meses) avisa e mantém o anterior. */
export function useCargaPeriodo(inicial: MonthRangeValue = periodoDoAno()) {
  const toast = useToast();
  const [periodo, setPeriodo] = useState<MonthRangeValue>(inicial);

  function escolherPeriodo(range: MonthRangeValue) {
    const erro = erroDoPeriodo(range);
    if (erro) {
      toast.warn(erro);
      return;
    }

    setPeriodo(range);
  }

  return { periodo, escolherPeriodo };
}

/** Período de uma aba: o da tela quando ela o entrega; usada isoladamente, a aba guarda o seu. */
export function usePeriodoDaAba(daTela: CargaPeriodo | undefined): CargaPeriodo {
  const proprio = useCargaPeriodo();
  return daTela ?? proprio;
}
